import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { ScrollArea } from '../components/ui/scroll-area';
import { ShieldCheck } from 'lucide-react';

const AcknowledgementPage = () => {
  const navigate = useNavigate();

  return (
    <div
      data-testid="acknowledgement-page"
      className="min-h-screen flex flex-col items-center justify-center relative overflow-hidden bg-white"
    >
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -right-40 w-96 h-96 bg-violet-50 rounded-full blur-3xl" />
        <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-violet-50 rounded-full blur-3xl" />
      </div>

      <div className="relative z-10 flex flex-col items-center gap-6 p-8 w-full max-w-2xl">
        <div className="flex items-center gap-3">
          <ShieldCheck className="w-8 h-8 text-violet-600" />
          <h1 className="text-2xl font-bold text-slate-900" style={{ fontFamily: 'Outfit, sans-serif' }}>
            Acknowledgement of Use
          </h1>
        </div>

        <Card className="w-full border-slate-200 shadow-lg">
          <CardContent className="p-0">
            <ScrollArea className="h-[340px] p-6">
              <div className="text-sm text-slate-700 leading-relaxed" data-testid="privacy-collection-notice">
                <h2 className="text-center font-bold text-slate-900 tracking-wide">
                  PRIVACY COLLECTION NOTICE
                </h2>
                <div className="h-5" />
                <div className="space-y-4 text-left">
                  <p>
                    This Privacy Collection Notice describes how Total Information Management
                    Consulting Pty Ltd (ABN 55 619 450 332) (<strong>we</strong>, <strong>us</strong>{' '}
                    or <strong>our</strong>) collects and handles your personal information when you
                    sign-up to do business with us. We collect personal information from you and from
                    third parties (such as our cookies and analytics providers) so that we can do
                    business with you and for related purposes set out in our Privacy Policy,
                    available on our website (or on request).
                  </p>
                  <p>
                    We may disclose this personal information to third parties, including our
                    personnel, related entities, any third parties engaged by us and acting on our
                    behalf and as otherwise set out in our Privacy Policy.
                  </p>
                  <p>
                    We store personal information in Australia. Where we disclose your personal
                    information to third parties, those third parties may store, transfer or access
                    personal information outside of Australia.
                  </p>
                  <p>
                    If you do not provide your personal information to us, it may affect our ability
                    to do business with you.
                  </p>
                  <p>
                    Please see our Privacy Policy for more information about how we collect, store,
                    use and disclose your personal information, including details about overseas
                    disclosure, access, correction, how you can make a privacy-related complaint and
                    our complaint-handling process.
                  </p>
                  <p>
                    If you have questions about our privacy practices, please contact us by email at:{' '}
                    <a href="mailto:info@timconsulting.com.au" className="text-violet-600 underline">
                      info@timconsulting.com.au
                    </a>
                    . By providing your personal information to us, you agree to the collection, use,
                    storage and disclosure of that information as described in this privacy
                    collection notice.
                  </p>
                </div>
              </div>
            </ScrollArea>
          </CardContent>
        </Card>

        <p className="text-sm text-slate-500 text-center">
          By clicking <strong>Accept &amp; Continue</strong> you acknowledge that you have read and
          agree to the terms above.
        </p>

        <Button
          data-testid="accept-acknowledgement-btn"
          onClick={() => navigate('/login')}
          className="bg-violet-600 hover:bg-violet-700 text-white px-12 py-6 text-lg font-semibold rounded-full shadow-xl hover:shadow-2xl transform transition-all duration-300 hover:-translate-y-1"
        >
          Accept &amp; Continue
        </Button>
      </div>
    </div>
  );
};

export default AcknowledgementPage;
